import {EntityState} from '@ngrx/entity';
import {ProjectEntity} from './entities/project-entity.model';

export type ProjectState = EntityState<ProjectEntity>;

export interface PartialProjectState {
  project: ProjectState;
}
